/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { FileType } from './FileType';
import { RuleType } from './RuleType';
const FileRuleParser = /* #__PURE__ */ parsers.object([
    ['fileType', FileType, 'file_type'],
    ['name', codecString],
    ['ruleType', RuleType, 'rule_type'],
]);
export class FileRule extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return FileRuleParser.decode(input).map(res => new FileRule(res));
    }
    static unsafeDecode(input) {
        return FileRule.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return FileRuleParser.encode(data);
    }
    static schema() {
        return FileRuleParser.schema();
    }
}
